import { render, staticRenderFns } from "./Partnership.vue?vue&type=template&id=2a692789&"
import script from "./Partnership.vue?vue&type=script&lang=js&"
export * from "./Partnership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports